import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-testdata-codemirror-dialog',
  templateUrl: './testdata-codemirror-dialog.component.html',
  styleUrls: ['./testdata-codemirror-dialog.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class TestdataCodemirrorDialogComponent {
  @Input() testdataValue: any;
  @Input() title: any;

  codeMirrorOptions: any = {
    mode: "application/json",
    lineNumbers: true,
    indentWithTabs: true,
    lineWrapping: true,
    foldGutter: true,
    gutters: ["CodeMirror-lint-markers"],
    lint: true,
  };

  constructor(private activeModal: NgbActiveModal, private modalService: NgbModal ) { 

  }

  closeCodemirrorDialog() {
    this.activeModal.close();
  }

  saveCodemirrorValue() {
    this.activeModal.close(this.testdataValue);
  }
}
